import { render, staticRenderFns } from "./OrderShipmentUpdate.vue?vue&type=template&id=8e967bc6&"
import script from "./OrderShipmentUpdate.vue?vue&type=script&lang=ts&"
export * from "./OrderShipmentUpdate.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports